import { format, startOfDay } from "date-fns";
import ExportDefinitionParametrDTO from "features/exports/dtos/ExportDefinitionParametrDTO";
import { FormExportParametersMap } from "features/exports/models/FormExportParametersMap";
import DataDescriptorDTO from "features/shared/dtos/DataDescriptorDTO";
import { BoolEnum } from "features/shared/enums/boolEnum";
import { FormFields } from "features/shared/forms/hooks/useForm";
import _ from "lodash";

// constants
export const customerParamName = "IdCustomer";
export const exportFileTypeKey = "ExportFileType";

// functions
export const getDataDescriptors = (
  values: FormFields,
  defParams: ExportDefinitionParametrDTO[]
): DataDescriptorDTO[] => {
  let exportParams: DataDescriptorDTO[] = [];

  for (const [key, value] of Object.entries(values)) {
    // skip file type
    if (key === exportFileTypeKey) {
      continue;
    }

    // fill only non empty values
    if (
      !(
        _.isNil(value) ||
        value === "" ||
        (Array.isArray(value) && (value as []).length === 0)
      )
    ) {
      const descriptor: DataDescriptorDTO = {
        code: key,
        value: getParamValue(key, value, defParams),
      };

      exportParams.push(descriptor);
    }
  }

  return exportParams;
};

export const formatDecimal = (value: any): string => {
  return String(value).replace(",", ".");
};

export const formatEnumMulti = (value: any): string => {
  if (Array.isArray(value) && (value as []).length > 0) {
    return (value as []).join(",");
  }

  return "";
};

export const formatBool = (value: any): string => {
  if (value === true) {
    return BoolEnum.True;
  } else if (value === false) {
    return BoolEnum.False;
  }

  return "";
};

export const formatDateTime = (value: any) => { 
  if (value) {
    const date = startOfDay(new Date(value));
    return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS");
  }

  return "";
}

// private
const getParamValue = (
  key: string,
  value: any,
  defParams: ExportDefinitionParametrDTO[]
): string => {
  const defParam = defParams.find((x) => x.exportDefinitionParametrId === key);

  if (defParam) {
    const paramConfig = FormExportParametersMap[defParam.dataType!];

    if (paramConfig.outputFormat) {
      return paramConfig.outputFormat(value);
    }
  }

  return String(value);
};
